import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const WalletContext = createContext(null);

export function WalletProvider({ children }) {
  const { user } = useAuth();
  const [wallet, setWallet] = useState({ balance: 0, seller_balance: 0, locked_balance: 0 });

  const refresh = useCallback(async () => {
    if (!user || user === false) {
      setWallet({ balance: 0, seller_balance: 0, locked_balance: 0 });
      return;
    }
    try {
      const { data } = await api.get("/wallet/me");
      setWallet(data);
    } catch {
      setWallet({ balance: 0, seller_balance: 0, locked_balance: 0 });
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <WalletContext.Provider value={{ ...wallet, refresh }}>
      {children}
    </WalletContext.Provider>
  );
}

export const useWallet = () => useContext(WalletContext);
